import React, { useContext, useState } from "react"
import { type LanguageCode, languageCode } from "~/consts/languages"
import { messages } from "~/locale/messages"
import { getPreferredLanguage, setPreferredLanguage } from "~/locale/util"
import { UseTranslateProvider } from "~/ur-react-hooks"

type LanguageContextType = [
  LanguageCode,
  (
    newLanguage: LanguageCode,
    onCompletedCallback?: (success: boolean) => void,
  ) => void,
]

const LanguageContext = React.createContext<LanguageContextType>([
  languageCode.NB,
  () => void 0,
])

export const useLanguage = () => useContext(LanguageContext)

type TranslationProviderProps = {}

export const TranslationProvider: React.CFC<TranslationProviderProps> = ({
  children,
}) => {
  const [language, setLanguage] = useState(() => getPreferredLanguage())

  async function handleSetLanguage(
    language: LanguageCode,
    onCompletedCallback?: (success: boolean) => void,
  ) {
    setPreferredLanguage(language)
    setLanguage(language)

    if (onCompletedCallback) {
      onCompletedCallback(true)
    }
  }

  return (
    <LanguageContext.Provider value={[language, handleSetLanguage]}>
      <UseTranslateProvider locale={language} messages={messages}>
        {children}
      </UseTranslateProvider>
    </LanguageContext.Provider>
  )
}
